/*
   Merch fiyat motoru — kademe tablosu + USD/TRY kuru.

   Üç yerde aynı sayının çıkması gerekiyor: ürün detayındaki adet paneli,
   sepet sayfasındaki tahmini tutar ve drawer'daki toplam. Kopyalanmış üç
   uygulamada biri değiştiğinde diğerleri sessizce farklı fiyat gösterirdi —
   üstelik fark ancak müşteri fark ettiğinde ortaya çıkardı. Bu yüzden motor
   burada tek, tüketiciler window.MerchPrice üzerinden okuyor.

   Merch Studio'nun kendi kontrolcüsü (merch-studio.js) hâlâ kendi kopyasını
   taşıyor; o sayfa bu dosyayı yüklemiyor. İkisi test ile karşılaştırılıyor.
*/
(function () {
  'use strict';

  function round2(n) { return Math.round(n * 100) / 100; }

  var tryFmt = new Intl.NumberFormat('tr-TR', {
    style: 'currency', currency: 'TRY', minimumFractionDigits: 2, maximumFractionDigits: 2
  });
  var usdFmt = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
  });

  /**
   * Kademe tablosundaki kırılım noktaları arasında doğrusal ara değer.
   * Excel'deki 984 satır, düzine kırılımlarında 4 banttan oluşan parçalı
   * doğrusal bir eğri; 8 kırılım noktası tabloyu birim başına 0.00008 USD
   * sapmayla üretiyor.
   */
  function unitUsd(ladder, qty) {
    if (!ladder || !ladder.anchors || !ladder.anchors.length) return null;
    var a = ladder.anchors;
    var min = typeof ladder.min === 'number' ? ladder.min : a[0][0];
    var max = typeof ladder.max === 'number' ? ladder.max : a[a.length - 1][0];
    var q = Math.min(Math.max(qty, min), max);

    if (q <= a[0][0]) return a[0][1];
    for (var i = 1; i < a.length; i++) {
      if (q <= a[i][0]) {
        var q0 = a[i - 1][0], p0 = a[i - 1][1];
        var q1 = a[i][0], p1 = a[i][1];
        if (q1 === q0) return p1;
        return p0 + (p1 - p0) * (q - q0) / (q1 - q0);
      }
    }
    return a[a.length - 1][1];
  }

  /**
   * Kademedeki USD KDV HARİÇ (Excel'in kendisi); `vat` yüzde olarak kademenin
   * içinde: Basics %10, Baskı/Nakış %20. Oran kademede çünkü sürüm fiyatı
   * tek başına belirlemeli — n8n aynı sürümün satırından kdv_orani'nı okuyup
   * aynı ifadeyi hesaplıyor. `vat` yoksa 0: eski sürümler değişmeden fiyatlar.
   */
  function vatOf(ladder) {
    return ladder && typeof ladder.vat === 'number' ? ladder.vat : 0;
  }

  /**
   * Yuvarlama ÖNCE birim fiyatta, sonra adetle çarpılıyor. Ters sırada
   * ekrandaki "birim × adet" müşterinin hesap makinesiyle tutmuyor: 650
   * adette ~2 TL'lik "olmayan kuruş" farkı çıkıyor.
   *
   * unitUsd net kalıyor (teklif gövdesi onu gönderiyor, sunucu kademeden
   * aynısını üretiyor); ekranda TL'nin yanına yazılan USD unitUsdGross —
   * KDV'li TL'nin yanında net USD, kurla çarpan müşteriye tutmazdı.
   */
  function priceFor(ladder, fxRate, qty) {
    var usd = unitUsd(ladder, qty);
    if (usd === null) return null;
    var vat = vatOf(ladder);
    var unitTry = round2(usd * fxRate * (1 + vat / 100));
    return {
      unitUsd: usd,
      unitUsdGross: usd * (1 + vat / 100),
      vat: vat,
      unitTry: unitTry,
      total: round2(unitTry * qty)
    };
  }

  window.MerchPrice = {
    round2: round2,
    unitUsd: unitUsd,
    vatOf: vatOf,
    priceFor: priceFor,
    money: function (n) { return n == null ? '—' : tryFmt.format(n); },
    usdMoney: function (n) { return n == null ? '—' : usdFmt.format(n); }
  };
})();
